export default "__VITE_ASSET__CyK8xVNE__"